import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import type { ProgramNewsRunType } from "@/services/adminProgramNews";
import { CLASSIFY_STOP_USD, classifyCostLabel, collectHoursLabel } from "./fullRunEstimates";

interface FullRunDialogProps {
  kind: ProgramNewsRunType;
  /** Verified sources (collect) or waiting articles (classify); null when not loaded. */
  count: number | null;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Plain-English confirmation shown before a full run starts. */
const FullRunDialog = ({ kind, count, open, onConfirm, onCancel }: FullRunDialogProps) => (
  <AlertDialog open={open} onOpenChange={next => (next ? undefined : onCancel())}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>
          {kind === "collect" ? "Run full collection?" : "Run full classification?"}
        </AlertDialogTitle>
        <AlertDialogDescription>
          {kind === "collect"
            ? `Visit every verified news feed${count === null ? "" : ` (about ${count} sources)`}. This takes ${collectHoursLabel(count)}. Articles are filed as they are found; you can leave this page.`
            : `Sort every article waiting in the queue${count === null ? "" : ` (about ${count})`}. One-time cost is ${classifyCostLabel(count)}. The run stops itself if it spends more than $${CLASSIFY_STOP_USD}.`}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm}>Start full run</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default FullRunDialog;
